import { Badge, Tooltip } from '@mantine/core';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import UserAvatar from 'src/Components/NavBar/UserAvatar';

import { Settings } from '../Settings';
import { useCommunityFeedItemToTag } from '../useCommunityFeedItemToTag';

import styles from './CommunityFeedItemTopRow.module.scss';
import { Props } from './CommunityFeedItemTopRow.props';

const CommunityFeedItemTopRow = ({ feedItem, onEdit, onDelete }: Props) => {
  const { t } = useTranslation();
  const assets = feedItem.assets
    .map(asset => asset.name)
    .sort((a, b) => a.localeCompare(b))
    .join(', ');
  const fullName = `${feedItem.author.firstName} ${feedItem.author.lastName}`;

  const date = dayjs(feedItem.createdAt).format('L');
  const time = dayjs(feedItem.createdAt).format('LT');

  const metadata = [];
  metadata.push(assets);
  metadata.push(t('community.postDate', 'Le {{date}} à {{time}}', { date, time }));
  if (feedItem.wasEdited) metadata.push(t('community.edited', 'Modifié'));

  const tag = useCommunityFeedItemToTag(feedItem);

  return (
    <>
      <div className={styles.firstRow}>
        <UserAvatar size={36} user={feedItem.author} />

        <div className={styles.authorColumn}>
          <Tooltip label={fullName} position="top-start">
            <span className={styles.authorName}>{feedItem.author.firstName}</span>
          </Tooltip>

          <span className={styles.authorSubtitle}>{metadata.join(' · ')}</span>
        </div>

        <Settings feedItem={feedItem} onEdit={onEdit} onDelete={onDelete} />
      </div>

      {tag ? (
        <Badge className={styles.type} leftSection={<tag.icon size={16} />}>
          {tag.label}
        </Badge>
      ) : null}
    </>
  );
};

export default CommunityFeedItemTopRow;
